"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var ShareIcon = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 15 18", fill: "currentColor", width: size || '15', height: size || '18' }, props),
        React.createElement("path", { fill: "currentColor", transform: "translate(-433 -512)", id: "a", d: "M438.135 520.094a2.642 2.642 0 0 1-.042 1.92l5.396 3.299a2.647 2.647 0 1 1-.669.832l-5.32-3.254a2.647 2.647 0 1 1 .082-3.699l5.247-3.32a2.647 2.647 0 1 1 .673.826l-5.367 3.396z", fillRule: "evenodd" })));
};
ShareIcon.displayName = 'ShareIcon';
exports.default = ShareIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ShareIcon.js.map